export const setSuperCategorySettings = items => {
  return {
    type: "SET_SUPER_CATEGORY_SETTINGS",
    items
  };
};

export const getSuperCategoriesSuggestions = payload => {
  return {
    type: "FETCH_SUPER_CATEGORIE_LIST",
    payload
  };
};

export const updateSuperCategorySettings = resp => ({
  type: "UPDATE_SUPER_CATEGORY_SETTINGS",
  payload: resp
});

export const saveSuperCategorySettings = resp => ({
  type: "SAVE_SUPER_CATEGORY_SETTINGS",
  payload: resp
});

export const deleteSuperCategorySettings = resp => ({
  type: "DELETE_SUPER_CATEGORY_SETTINGS",
  payload: resp
});



// WEBPACK FOOTER //
// ./src/actions/actions/super-categories.js